module.exports = __webpack_public_path__ + "static/media/jenkins.bb04496c.png";